import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import CalendarInput from "../../../components/input/CalendarInput";
//services
import { getExtract } from "../../../services/Wallet/getExtract";
//utils
import { formatCurrency } from "../../../utils/formatCurrency";
import { formatDate } from "../../../utils/formatDate";
// imagem
import darkLogoWallet from "../../../assets/banks/logo-wallet-dark.png";

const WalletExtract = () => {
  const form = useForm();
  const { state } = useLocation();
  const navigate = useNavigate();
  const hasNavigated = useRef(false);
  //  console.log(state);
  const errors = form.formState.errors;

  const [extract, setExtract] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const columns = [
    { field: "id", header: "Código" },
    { field: "parcel", header: "Parcela" },
    { field: "client", header: "Cliente" },
    { field: "date", header: "Data" },
    { field: "description", header: "Descrição" },
    { field: "status", header: "Status" },
    { field: "value", header: "Valor" },
    { field: "dataLiberacao", header: "Data Liberação" },
    { field: "saldo", header: "Saldo Após" },
  ];

  // useEffect(() => {
  //   if (state && state.token_lt) {
  //     const sendData = {
  //       token_lt: state.token_lt,
  //       inicio: new Date(),
  //       fim: new Date(),
  //     };
  //     const response = getExtract(sendData);
  //     const tableData = response.extrato.map(e => (
  //       {
  //         id: e.id_saldo,
  //         parcel: e.lt_idparcelas,
  //         client: e.lt_nome_cli,
  //         date: e.data_op,
  //         description: e.lt_descricao_empreendimento,
  //         status: statusName(e.status_op),
  //         value: formatCurrency(e.valor_op),
  //         dataLiberacao: e.saldo_data_liberacao,
  //         saldo: formatCurrency(e.saldo_apos),
  //       }
  //     ));
  //     setExtract(tableData);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleExportExcel = () => {
    const mapedHeader = columns.map(col => col.header);
    const ws = XLSX.utils.json_to_sheet(extract, { header: columns.map(col => col.field) });
    XLSX.utils.sheet_add_aoa(ws, [mapedHeader], { origin: "A1" });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Extrato");
    XLSX.writeFile(
      wb,
      `Extrato_${new Date().toISOString().split("T")[0]}.xlsx`
    );
  };

  const handleExportPDF = () => {
    if (!extract || extract.length === 0) {
      toast.warning("Não há dados para exportar");
      return;
    }

    // if (isExporting) {
    //   toast.loading("Exportação em andamento, aguarde...");
    //   return;
    // }

    setIsExporting(true);

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const dateFirst = form.getValues("dateFirst");
    const dateEnd = form.getValues("dateEnd");
    const periodo = `${
      dateFirst ? new Date(dateFirst).toLocaleDateString("pt-BR") : "N/A"
    } - ${dateEnd ? new Date(dateEnd).toLocaleDateString("pt-BR") : "N/A"}`;

    const formatDateSafe = (dateString) => {
      if (!dateString) return "";

      try {
        const formattedDate = formatDate(dateString);
        return formattedDate || "";
      } catch (error) {
        console.log("Erro ao formatar data:", dateString, error);
        return "";
      }
    };

    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, 297, 210, "F");

    let pdfGenerated = false; 

    const continuePDF = () => {
      if (pdfGenerated) return; 
      pdfGenerated = true;

      doc.setFontSize(18);
      doc.setTextColor(0, 51, 78);
doc.text("Extrato de Conta", 200, 40, { align: "left" });     // 30 → 40

      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.text("Banco IB3 Capital", 200, 47, { align: "left" });
      doc.text(`Período: ${periodo}`, 200, 54, { align: "left" });

      doc.setDrawColor(0, 169, 157);
      doc.setLineWidth(0.5);
      doc.line(20, 55, 277, 55);

      const tableData = extract.map((row) => [
        row.id || "",
        row.parcel || "", 
        row.client || "",
        formatDateSafe(row.date),
        row.description || "",
        row.status || "",
        row.value || "",
        formatDateSafe(row.dataLiberacao),
        row.saldo || "",
      ]);

      doc.autoTable({
        head: [["Código", "Parcela", "Cliente", "Data", "Descrição", "Status", "Valor (R$)", "Data Liberação", "Saldo Após (R$)"]],
        body: tableData,
        startY: 65,
        theme: "plain",
        headStyles: {
          fillColor: [248, 249, 250],
          textColor: [52, 58, 64],
          fontSize: 8,
          fontStyle: "bold",
          lineWidth: 0.1,
          lineColor: [220, 220, 220],
        },
        bodyStyles: {
          fontSize: 7,
          textColor: [73, 80, 87],
          lineWidth: 0.1,
          lineColor: [240, 240, 240],
        },
        columnStyles: {
          0: { cellWidth: 20 }, // Código
          1: { cellWidth: 20 }, // Parcela
          2: { cellWidth: 35 }, // Cliente
          3: { cellWidth: 25 }, // Data
          4: { cellWidth: 50 }, // Descrição
          5: { cellWidth: 25 }, // Status
          6: { cellWidth: 25, halign: "right" }, // Valor
          7: { cellWidth: 25 }, // Data Liberação
          8: { cellWidth: 30, halign: "right" }, // Saldo Após
        },
        margin: { left: 20, right: 20 },
        styles: {
          lineColor: [240, 240, 240],
          lineWidth: 0.1,
          cellPadding: 2,
        },
        alternateRowStyles: {
          fillColor: [252, 252, 252],
        },
      });

      const finalY = doc.lastAutoTable.finalY + 20;
      doc.setFontSize(7);
      doc.setTextColor(180, 180, 180);
      doc.text(
        "Este é um documento gerado eletronicamente. Para mais detalhes, acesse sua conta no APP IB3.",
        148,
        finalY,
        { align: "center" }
      );
      doc.text(
        "IB3 Capital S.A. - Todos os direitos reservados.",
        148,
        finalY + 6,
        { align: "center" }
      );

      const filename = `Extrato_${new Date().toISOString().split("T")[0]}.pdf`;
      doc.save(filename);

      setIsExporting(false);
      // toast.success("PDF exportado com sucesso!");
    };

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = darkLogoWallet;

    img.onload = function () {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = this.width;
        canvas.height = this.height;
        ctx.drawImage(this, 0, 0);
        const dataURL = canvas.toDataURL("image/png");

        const logoWidth = 50;
        const logoHeight = (this.height / this.width) * logoWidth;

        doc.addImage(dataURL, "PNG", 20, 17, logoWidth, logoHeight);
        continuePDF();
      } catch (error) {
        console.log("Erro ao processar logo:", error);
        continuePDF();
      }
    };

    img.onerror = function () {
      console.log("Erro ao carregar logo, continuando sem ele");
      continuePDF();
    };

    // Fallback apenas se não carregar em 2 segundos
    setTimeout(() => {
      if (!pdfGenerated) {
        console.log("Timeout - gerando PDF sem logo");
        continuePDF();
      }
    }, 2000);
  };

  const onSubmit = async (data) => {
    //    console.log(data);
    const notification = toast.loading("Realizando o estorno de recebimento..");
    setLoading(true);
    const sendData = {
      token_lt: state.token_lt,
      start: data.dateFirst,
      end: data.dateEnd,
    };
    const response = await getExtract(sendData);
    // console.log(response);
    if (response.extrato) {
      const tableData = response.extrato.map((e) => ({
        id: e.id_saldo,
        parcel: e.lt_idparcelas,
        client: e.lt_nome_cli,
        date: formatDate(e.data_op),
        description: e.descricao_op,
        status: statusName(e.status_op),
        value: formatCurrency(e.valor_op),
        dataLiberacao: e.saldo_data_liberacao,
        saldo: formatCurrency(e.saldo_apos),
      }));
      setExtract(tableData);
      setLoading(false);

      toast.update(notification, {
        render: "Busca realizada com sucesso!",
        type: "success",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } else {
      setLoading(false);
      toast.update(notification, {
        render: response.error.message,
        type: "warning",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
  };

  function statusName(id) {
    let name;
    switch (id) {
      case 0:
        name = "Processamento";
        break;
      case 1:
        name = "Efetivado";
        break;
      default:
        break;
    }
    return name;
  }

  const items = [
    {
      template: () => (
        <Link to={"/wallet/dashboard"} className="p-breadcrumb-link">
          Extrato
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/wallet/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  useEffect(() => {
    if (state === null && !hasNavigated.current) {
      hasNavigated.current = true;
      toast.warning("Houve um erro a buscar os dados, tente novamente");
      navigate("/wallet/dashboard");
    }
  }, [state, navigate]);

  return (
    <>
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <div className="row">
        <Panel>
          <h4>Extrato por Período</h4>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-4">
                <CalendarInput
                  name="dateFirst"
                  control={form.control}
                  errors={errors}
                  label={`Data Inicial`}
                />
              </div>
              <div className="col-md-4">
                <CalendarInput
                  name="dateEnd"
                  control={form.control}
                  errors={errors}
                  maxDate={new Date()}
                  label={`Data Final`}
                />
              </div>
              <div className="col-md-4 pt-3">
                <Button
                  rounded
                  type="submit"
                  iconPos="left"
                  label="Consultar"
                  icon="fa-solid fa-magnifying-glass"
                  className="p-inputtext-sm m-auto w-100"
                  loading={loading}
                />
              </div>
            </div>
          </form>
        </Panel>

        <Panel mainCss="mt-4">
          <div className="d-flex gap-2 mb-3 justify-content-end">
            <Button
              icon="fa fa-file-pdf"
              className="p-button-secondary cursor-pointer"
              tooltip="Exportar para PDF"
              rounded
              tooltipOptions={{ position: "bottom" }}
              onClick={handleExportPDF}
              loading={isExporting}
              disabled={isExporting || !extract || extract.length === 0}
            />
            <Button
              icon="fa fa-file-excel"
              className="p-button-success cursor-pointer"
              tooltip="Exportar para Excel"
              tooltipOptions={{ position: "bottom" }}
              rounded
              onClick={handleExportExcel}
              disabled={!extract || extract.length === 0}
            />
          </div>
          <div className="" id="extract">
            <h4>Extrato</h4>
            <DataTable
              rows={5}
              paginator
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="single"
              rowsPerPageOptions={[5, 25, 100]}
              value={extract}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
            >
              {columns.map((col) => (
                <Column
                  sortable
                  key={col.field}
                  field={col.field}
                  header={col.header}
                />
              ))}
            </DataTable>
          </div>
        </Panel>
      </div>
    </>
  );
};

export default WalletExtract;
